<template>
  <div class="content-our-photo">
    <div class="content-our-photo--title">
      <h2>{{ title }}</h2>
    </div>
    <div class="content-our-photo-body">
      <input
        type="file"
        ref="fileuploadimage"
        name="picture"
        id="image-category"
        @change="previewImage($event)"
        accept="image/*"
        :required="!imageFileUrl"
      />
      <label class="btn--new-photo" for="image-category">
        <img
          class="img-fluid"
          src="@/assets/img/icon-add.png"
          alt="icon plus"
          title="icon plus"
        />
      </label>
      <div class="content-our-photo-body-image" v-if="imageFileUrl">
        <button
          class="content-our-photo-body-image--bg"
          type="button"
          :style="{ background: `url(data:image/jpg;base64,${imageFileUrl})` }"
        ></button>
        <button
          class="btn-remove-photo"
          type="button"
          @click="clearInputFile()"
        >
          <img
            class="img-fluid"
            src="@/assets/img/icon-close.png"
            alt="icon remove"
            title="icon remove"
          />
        </button>
      </div>
      <span class="content-our-photo-body--proportion">
        <template v-if="proportion">
          {{ proportion }}
        </template>
        <template v-else> Proporção: 128x128 </template>
      </span>
    </div>
  </div>
</template>

<script>
import mixinUploadImage from "@/mixins/mixinUploadImage";

export default {
  mixins: [mixinUploadImage],
};
</script>
